class GiftWrap extends HTMLElement {
  connectedCallback() {
    this.variantId = this.dataset.variantId;
    this.checkbox = this.querySelector('[data-gift-wrap-toggle]');
    if (this.checkbox) {
      this.checkbox.addEventListener('change', () => this.onToggle());
    }
  }

  setBusy(state) {
    this.classList.toggle('gift-wrap--busy', state);
    if (this.checkbox) this.checkbox.disabled = state;
  }

  async onToggle() {
    this.setBusy(true);
    try {
      if (this.checkbox.checked) {
        await this.add();
      } else {
        await this.remove();
      }
      // Re-render cart so totals/lines update.
      window.location.reload();
    } catch (e) {
      this.checkbox.checked = !this.checkbox.checked;
      this.setBusy(false);
    }
  }

  async add() {
    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(this.variantId), quantity: 1 }] }),
    });
    if (!res.ok) throw new Error('add failed');
  }

  async remove() {
    // Find the line item key for the gift-wrap variant, then set quantity 0.
    const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
    const line = cart.items.find((i) => i.variant_id === Number(this.variantId));
    if (!line) return;
    const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 }),
    });
    if (!res.ok) throw new Error('remove failed');
  }
}

if (!customElements.get('gift-wrap')) {
  customElements.define('gift-wrap', GiftWrap);
}
